import { AbstractControl, ValidationErrors } from '@angular/forms';

export function requireMatch(abstractControl: AbstractControl): ValidationErrors | null {
    const selection: any = abstractControl.value;
    if (typeof selection === 'string' && selection.trim() !== '') {
        return { requireMatch: true };
    }
    return null;
}
